<template>
    <Modal class-name="scrollable vertical-center-modal" title="Editar área" v-model="show" :footer-hide="true" :scrollable="true">
        <Form style="width: 100%" ref="planForm" :model="program" :rules="ruleInline">
            <Row :gutter="16">
                <i-col span="24">
                    <FormItem label="Nombre" prop="name">
                        <Input :autosize="{minRows: 5,maxRows: 8}" v-model="program.name" placeholder="Nombre"/>
                    </FormItem>
                    <FormItem label="Programa activo" prop="enable">
                        <Checkbox v-model="program.enable" />
                    </FormItem>
                </i-col>
                <i-col span="24">
                    <Button style="margin-top: 25px" size="large" long type="primary" :loading="loading" @click="save">Actualizar</Button>
                </i-col>
            </Row>
        </Form>
    </Modal>
</template>

<script>
    export default {
        data(){
            return {
                show: false,
                program: {
                    name: ""
                },
                loading: false,
                ruleInline: {
                    name: [
                        { required: true, message: 'Nombre es requerido', trigger: 'change' },
                    ],
                },
            }
        },
        methods: {
            save(){
                this.$refs.planForm.validate(valid => {

                    if(valid){
                        this.loading = true
                        window.axios.post(this.$root.API_URL + `/programs/update/${this.program.id}`, { name: this.program.name, enable:
                            this.program.enable })
                        .then(response => {
                            if(response.data.success){
                                window.EventBus.$emit('program--update-program', response.data.program)
                                this.show = false
                                this.loading = false
                            }
                        })
                        .catch(() => {
                            this.loading = false
                            this.$Message.error('Hubo un problema, no pudimos completar esta acción');
                        })
                    }
                })
            },
        },
        mounted(){
            window.EventBus.$on('program--edit-program', (program) => {
                this.program = { ...program }
                this.show = true
            })
        }
    }
</script>